<script setup lang="ts">
defineProps<{
  companyName: string
  overview: string
}>()
</script>

<template>
  <section>
    <p class="text-gray-700 text-lg leading-relaxed">
      {{ overview }}
    </p>
  </section>
</template>
